import React from 'react';
import { ADMIN_ROLE } from '../../../constants/global';
import Util from '../../../utils/APCPUtil';
import './apcptable.scss';
import QuestionsPanel from './questionsPanel';
import Tooltip from '../../Tooltip';

const TableHeaders = () => (
  <thead>
    <tr style={{backgroundColor: 'white'}}>
      <th scope='col' className='header' id={`id${2}head`} key={`id${2}head`} style={{textAlign:'left'}}>Advanced Placement Exam</th>
      <th scope='col' className='header' id={`id${3}head`} key={`id${3}head`}>Minimum Score</th>
      <th scope='col' className='header' id={`id${4}head`} key={`id${4}head`}>Credits Earned</th>
      <th scope='col' className='header' id={`id${5}head`} key={`id${5}head`}>Course Equivalency</th>
      <th scope='col' className='header' id={`id${6}head`} key={`id${6}head`}>Applicable Program</th>
      <td className='header' id={`id${7}head`} key={`id${7}head`}></td>
    </tr>
  </thead>);

const NewPolicyRow = ({questions, moduleData, setModuleData, answers, setAnswers, 
  moduleErrors, setModuleErrors, questionTemplate, setQuestionTemplate, 
  appliedModuleIds,setAppliedModuleIds,moduleIdMap, setPageDirty, readOnly, setEnableEdit, setEnableNewPolicy,setEnableRenderBtn})=>{

    const [newError, setNewError] = React.useState([]);
    
    questions?.questions.forEach(question => {
      if(question?.data_required && !question?.hasOwnProperty('current_value') ){
          question.current_value = '';
      }
  })
    return (<>
    <tr className="cb-table-expandable-row bluepanel">
        <td colSpan="6" className="cb-table-expandable-container">
          <div>
            <QuestionsPanel 
              index={99999}
              moduleData={questions}
              org_rol={ADMIN_ROLE}
              moduleAnswers={answers}
              setModuleAnswers={setAnswers}
              moduleErrors={newError}
              setModuleErrors={setNewError} 
              newpolicy={true}
              statusOfModule={readOnly} />

          </div>
          <div style={{display:'flex', marginTop:'40px', justifyContent:'flex-end'}}>
         
            <div className='col-md-6' style={{textAlign:'right', paddingRight:'50px', marginBottom:'20px'}}>
              <button type="button" className="cb-btn cb-btn-naked" disabled={readOnly}
                onClick={()=>{
                  setEnableEdit(true);
                  setEnableNewPolicy(true);
                  setEnableRenderBtn(true);
                  setQuestionTemplate(()=>{return undefined;});
                  document.getElementById('btn_newPolicyBtn').focus();
                }}>
                <p className='center'>Cancel</p>
              </button>

              <button type="button" 
                      className="cb-btn cb-btn-primary"
                      disabled={Util.checkModuleErrors(newError
                      )||readOnly?'disabled':null}
                onClick={()=>{
                  const newrow = Util.addModuleByAnswers(moduleData, answers, moduleIdMap, questionTemplate);
                  moduleData.push(newrow);
                  setModuleData(()=>Util.sortAPCP([...moduleData]));
                  setQuestionTemplate(()=>{return undefined;});
                  const newMid = newrow['rowData'].moduleId;
                  let newApplied = new Set(appliedModuleIds);
                  const pureModuleIdarr = newMid.split('-');
                  newApplied.add(pureModuleIdarr[0]);
                  setPageDirty('Y');
                  setAppliedModuleIds( Array.from(newApplied));
                  setAnswers({});
                  setEnableEdit(true);
                  setEnableNewPolicy(true);
                  setEnableRenderBtn(true);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}>
                  <p className='center'>Add Policy</p>
              </button>
            </div>
          </div>
        </td>
    </tr>
    </>
);};

const TableRow = ({row, index,currentModuleId, 
                  setCurrentModuleId, questionData, 
                  moduleData, setModuleData, 
                  answers, setAnswers, 
                  appliedModuleIds,setAppliedModuleIds,
                  moduleErrors,setModuleErrors, setPageDirty, readOnly, enableEdit, setEnableEdit, setEnableNewPolicy,
                  setEnableRenderBtn}) => {
  
  return(
    <>
    <tr className={row.bgColor} id={`row-${row.moduleId}`}>
      <td className='cell' style={{width:'30%', textAlign:'left'}}>
        <Tooltip tooltipid={`tooltip_${row.moduleId}`} tooltipMsg={row.examTitle} innerMsg={row.seTitle} />
      </td>
      <td style={{width:'10%'}} className='cell'>{row.apcpMinScoreRequired}</td>
      <td style={{width:'10%'}} className='cell'>{row.apcpCreditsAwarded}</td>
      <td className='cell' style={{wordBreak:'break-all'}}>{row.apcpCourseEquivalent}</td>
      <td className='cell' style={{width:'10%'}}>{row.apcpSchoolMajor}</td>
      <td className='cell' style={{width:'10%'}}>
        <button type="button" className="cb-btn cb-btn-naked" 
              aria-labelledby={`tooltip_${row.moduleId}`}
              disabled={!enableEdit}
              onClick={() => {
                setCurrentModuleId(row.moduleId);
                document.getElementById(`expandRow-${row.moduleId}`).classList.remove('cb-hidden');
                document.getElementById(`expandRow-${row.moduleId}`).setAttribute('aria-hidden', false);
                document.getElementById(`row-${row.moduleId}`).classList.remove(`${row.bgColor}`);
                document.getElementById(`row-${row.moduleId}`).classList.add('bluerow');

                //disable all other edit button
                setEnableEdit(false);
                setEnableNewPolicy(false);
                setEnableRenderBtn(false);
                
              }}
            key={`btn_edit_${row.moduleId}`}
            id={`btn_edit_${row.moduleId}`}
          >
          <p className='center'>Edit</p>
          </button>
      </td>
    </tr>

    <tr className="cb-table-expandable-row cb-hidden bluepanel" aria-hidden="true" id={`expandRow-${row.moduleId}`}>
        <td colSpan="6" className="cb-table-expandable-container">
          <div>
            {currentModuleId===row.moduleId?
            <QuestionsPanel 
              index={index}
              moduleData={questionData}
              org_rol={ADMIN_ROLE}
              moduleAnswers={answers}
              setModuleAnswers={setAnswers}
              moduleErrors={moduleErrors}
              setModuleErrors={setModuleErrors} 
              newpolicy={false}
              statusOfModule={readOnly} />:null}
          </div>
          <div style={{display:'flex', marginTop:'40px', marginBottom:'20px'}}>
            <div style={{flex:1}}>
              <button type="button" className="cb-btn cb-btn-naked" style={{marginLeft:'15px'}}
                disabled={readOnly}
                onClick={()=>{
                  const moduleId = `${row.moduleId}`;
                  const pureModuleIdarr = moduleId.split('-');
                  const newArr = Util.deleteModuleById(moduleData, moduleId);
                  setModuleData(Util.sortAPCP(newArr));
                  setEnableEdit(true);
                  setEnableNewPolicy(true);
                  setEnableRenderBtn(true);
                  setModuleErrors({});
                  let newApplied = new Set(appliedModuleIds);
                  newApplied.add(pureModuleIdarr[0]);
                  setAppliedModuleIds(Array.from(newApplied));
                  setPageDirty('Y');
                  setAnswers({});
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}>
                <p className='center'>Delete</p>
              </button>
            </div>

            <div style={{flex:1, textAlign:'right', paddingRight:'50px'}}>
              <button type="button" className="cb-btn cb-btn-naked" 
                onClick={()=>{
                  document.getElementById(`expandRow-${row.moduleId}`).classList.add('cb-hidden');
                  document.getElementById(`expandRow-${row.moduleId}`).setAttribute('aria-hidden', true);
                  document.getElementById(`row-${row.moduleId}`).classList.add(`${row.bgColor}`);
                  document.getElementById(`row-${row.moduleId}`).classList.remove('bluerow');
                  //update display data of table AND answers for questions for saving
                  setEnableEdit(true);
                  setEnableNewPolicy(true);
                  setEnableRenderBtn(true);
                  setCurrentModuleId(0);
                  setModuleErrors({});
                  setAnswers({});
                  document.getElementById(`btn_edit_${row.moduleId}`).focus();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}>
                <p className='center'>Cancel Edit</p>
              </button>

              <button type="button" 
                      className="cb-btn cb-btn-primary"
                      disabled={Util.checkModuleErrors(moduleErrors)||readOnly?'disabled':null}
                onClick={()=>{
                  document.getElementById(`expandRow-${row.moduleId}`).classList.add('cb-hidden');
                  document.getElementById(`expandRow-${row.moduleId}`).setAttribute('aria-hidden', true);
                  document.getElementById(`row-${row.moduleId}`).classList.add(`${row.bgColor}`);
                  document.getElementById(`row-${row.moduleId}`).classList.remove('bluerow');
                  //update tableData, answers for questions for saving and sample data currentValue
                  const moduleId = `${row.moduleId}`;
                  const pureModuleIdarr = moduleId.split('-');
                  const newArr = Util.updateModuleByAnswers(moduleData, answers, moduleId);
                  setModuleData(Util.sortAPCP(newArr));
                  setEnableEdit(true);
                  setEnableNewPolicy(true);
                  setEnableRenderBtn(true);
                  setCurrentModuleId(0);
                  let newApplied = new Set(appliedModuleIds);
                  newApplied.add(pureModuleIdarr[0]);
                  setAppliedModuleIds( Array.from(newApplied));
                  setPageDirty('Y');
                  setAnswers({});
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}>
                  <p className='center'>Apply</p>
                </button>
            </div>
          </div>
        </td>
    </tr>
      </>
  );
};

const Table = ( { moduleData, setModuleData, 
                  answers, setAnswers, 
                  appliedModuleIds,setAppliedModuleIds,
                  moduleErrors, setModuleErrors,questionTemplate,setQuestionTemplate,
                  moduleIdMap, setPageDirty,
                  readOnly, enableEdit,setEnableEdit,enableNewPolicy,
                  setEnableNewPolicy, enableRenderBtn,
                  setEnableRenderBtn
                } ) => {
  const [currentModuleId, setCurrentModuleId] = React.useState(0);
  return (
    <div>
        <table className='cb-table cb-table-light' id='examTable'>
          <TableHeaders />
          <tbody>
            {
          questionTemplate?
            <NewPolicyRow 
                questions = {questionTemplate}
                moduleData = {moduleData}
                setModuleData={setModuleData} 
                answers={answers} 
                setAnswers={setAnswers} 
                moduleErrors={moduleErrors}
                setModuleErrors={setModuleErrors}
                questionTemplate={questionTemplate}
                setQuestionTemplate={setQuestionTemplate}
                appliedModuleIds={appliedModuleIds}
                setAppliedModuleIds={setAppliedModuleIds}
                moduleIdMap={moduleIdMap}
                setPageDirty={setPageDirty}
                readOnly={readOnly}
                setEnableEdit={setEnableEdit}
                setEnableNewPolicy={setEnableNewPolicy}
                setEnableRenderBtn={setEnableRenderBtn}
                />:null}
            {
              moduleData?.length > 0?moduleData?.map((module, index) => {

              return <TableRow 
                      key={`tablerow-${module.rowData.moduleId}`} 
                      currentModuleId={currentModuleId}
                      setCurrentModuleId={setCurrentModuleId}
                      row={module.rowData} index={index}
                      questionData={module.data}
                      moduleData = {moduleData}
                      setModuleData={setModuleData} 
                      answers={answers} 
                      setAnswers={setAnswers}
                      appliedModuleIds = {appliedModuleIds}
                      setAppliedModuleIds = {setAppliedModuleIds}
                      moduleErrors={moduleErrors}
                      setModuleErrors={setModuleErrors}
                      setPageDirty={setPageDirty}
                      readOnly={readOnly}
                      enableEdit={enableEdit}
                      setEnableEdit={setEnableEdit}
                      setEnableNewPolicy={setEnableNewPolicy}
                      setEnableRenderBtn={setEnableRenderBtn}
                    />;
              }):
              <tr><td colSpan={6}><p id='nomajselected'>No policies</p></td></tr>
            }
          </tbody>
        </table>
    </div>
  );
};
export default Table;